module.exports = __webpack_public_path__ + "media/24.b31a87f4.mp3";